import { createSelector } from "reselect";
import { initialState } from "./reducer";
import { compareString } from "helpers/generalUtils";

const reducerState = (state) => state.CategoryMaster || initialState;

const makeCategorySelectField = (field) =>
  createSelector(reducerState, (categoryState) => categoryState[field]);

const selectSortedCategories = () =>
  createSelector(makeCategorySelectField("categoryList"), (categories) =>
    categories
      .map((opt) => ({
        value: opt.categoryId,
        label: opt.categoryName,
      }))
      .sort((item1, item2) => compareString(item1.label, item2.label))
  );

const selectSortedCategoriesForProductCategory = () =>
  createSelector(makeCategorySelectField("categoryList"), (categories) =>
    categories
      .map((opt) => ({
        value: opt.categoryId,
        label: opt.parentId
          ? opt.parentName + " -> " + opt.categoryName
          : opt.categoryName,
      }))
      .sort((item1, item2) => compareString(item1.label, item2.label))
  );
export {
  reducerState,
  makeCategorySelectField,
  selectSortedCategories,
  selectSortedCategoriesForProductCategory,
};
